interface ResponsiveImage {
	webp?: string | null;
	original?: string | null;
	image?: string | null;
	srcset?: string | null;
}

/**
 * URL for CSS background images, which can not use "srcset": the smallest responsive variant that is
 * wide enough for the viewport (at most 2x pixel density), otherwise the plain image URL.
 */
export const pickImageUrl = (image: string | ResponsiveImage | null | undefined, maxCssWidth: number = Infinity): string => {
	if (!image) {
		return '';
	}
	if (typeof image === 'string') {
		return image;
	}

	const fallback = image.webp ?? image.original ?? image.image ?? '';
	if (!image.srcset) {
		return fallback;
	}

	const target = Math.min(window.innerWidth, maxCssWidth) * Math.min(window.devicePixelRatio || 1, 2);
	const candidates = image.srcset
		.split(',')
		.map((candidate) => candidate.trim().split(/\s+/))
		.map(([url, width]) => ({url, width: parseInt(width, 10)}))
		.filter((candidate) => candidate.url && candidate.width > 0)
		.sort((a, b) => a.width - b.width);

	return (candidates.find((candidate) => candidate.width >= target) ?? candidates[candidates.length - 1])?.url ?? fallback;
};
